import{a as e}from"./chunk-MB4XIAOG.mjs";import{b as m}from"./chunk-LSZKOVGW.mjs";import{j as o,k as r}from"./chunk-SGUETU3K.mjs";var i=new o({locale:[e,m,r]});export{i as a};
